<template lang="pug">
  b-modal#updateAuthority(
    ref="updateAuthority"
    :title="$t('ui.combine.edit_authority')"
    centered
    no-fade
    no-close-on-backdrop
    :busy="loading"
    size="md"
    @ok="done"
    @show="reset"
    @shown="shown"
  )
    b-form(novalidate :disabled="!submission.success" @submit.stop.prevent="submit")
      .form-group
        label {{ $t("ui.account_id") }}
        DebounceInput(
          type="text"
          ref="account_id"
          :placeholder='$t("ui.account_id")'
          :value="accountId.toUpperCase()"
          readonly
        )
      .form-group
        label {{ $t('ui.authority_option') }}
        b-form-checkbox-group(
          ref="authority_option"
          v-model="authority_option"
          :disabled="loading"
          :options="authorityList"
          size="md"
        )
      .form-group
        b-alert.alert-sm.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-times" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, minLength, maxLength, sameAs, helpers } from "vuelidate/lib/validators";
import config from "@/config";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    accountId: ""
  },
  data() {
    return {
      authority_option: [],
      loading: false,
      submission: {
        success: true,
        status: ""
      }
    };
  },
  validations: {},
  computed: {
    authorityList: function() {
      let list = this.$store.getters.accessOptions
      let result = []
      list.forEach( value => {
        result.push({value:value, text:this.$t("ui." + value)})
      })
      return result
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    getSubAccountDetails: function() {
      let sub_login_id = this.accountId
      this.loading = true
      if(sub_login_id) {
        this.$store
        .dispatch("user/getSubAccountDetails", { sub_login_id })
        .then(response => {
          this.loading = false
          if (response.data.details[0].authority_option) {
            this.authority_option = response.data.details[0].authority_option.split(",").sort()
          }
        })
        .catch(response => {
          console.log("Failed:getSubAccountDetails", response)
          this.loading = false
        });
      } else {
        this.cancel()
      }
    },
    submit: function() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.loading = true
        this.$swal({
          title: this.$t("ui.status"),
          text: this.$t("message.update_account_authority_confirm"),
          type: "warning",
          showCancelButton: true,
          allowOutsideClick: false
        }).then(result => {
          if (result.value) {
            this.updateAuthority()
          } else if (
            // Read more about handling dismissals
            result.dismiss === 'cancel'
          ) {
            this.loading = false
            this.$swal({
              title: this.$t("ui.cancel"),
              text: this.$t("message.update_account_authority_cancel"),
              type: "error",
              allowOutsideClick: false
            }).then(isConfirm => {
              if (isConfirm) {
                this.cancel()
              }
            });
          }
        });
      }
    },
    updateAuthority: function() {
      let login_id = this.accountId
      let authority_option = this.authority_option;
      this.loading = true;
      this.$store
        .dispatch("user/updateAuthority", { login_id, authority_option })
        .then(response => {
          this.loading = false;
          this.submission.success = response.success;
          this.submission.status = response.status;
          if (this.submission.success == true) {
            this.loading = false
            this.$swal({
              title: this.$t("ui.succeed"),
              text: this.$t("message.update_account_authority_success"),
              type: "success",
              allowOutsideClick: false
            }).then(isConfirm => {
              if (isConfirm) {
                this.cancel();
              }
            });
          }
        })
        .catch(response => {
          console.log("Failed:updateAuthority", response)
          this.loading = false;
          this.submission.success = response.success
          this.submission.status = this.$t("message." + response.errorTag)
        });
    },
    reset: function() {
      this.submission.success = true
      this.submission.status = ""
      this.authority_option = []
    },
    shown: function() {
      this.$nextTick(() => {
        this.$v.$reset()
        this.getSubAccountDetails()
      });
    },
    cancel: function() {
      this.$emit("clicked")
      this.$refs.updateAuthority.hide()
    }
  }
};
</script>

